import React, { useState, useCallback, useRef } from 'react';
import { useModal } from '../../../modules/ui';
import { useProfileModal } from '../UserGroup/ProfileModal/useProfileModal';

export const useRightSidebar = () => {
    const { boundToggleRightSidebar } = useModal();
    const { aud, url } = useProfileModal();
    const [isOpenProfileModal, setIsOpenProfileModal] = useState(false);
    const ref = useRef();
    const toggleProfileModal = useCallback(
        () => setIsOpenProfileModal(!isOpenProfileModal),
        [setIsOpenProfileModal, isOpenProfileModal]
    )

    const closeRightSidebar = useCallback(
        () => boundToggleRightSidebar(false),
        [boundToggleRightSidebar]
    )

    return {
        ref, aud, url, closeRightSidebar, isOpenProfileModal, toggleProfileModal
    }
}